import { useCallback, useEffect, useState } from 'react';

// Estado normalizado das automacoes do Seller, servido por
// GET /api/seller/automation/status (sellerAutomationService no backend).
// Todas as abas leem daqui para montar o mesmo cabecalho.
export interface SellerAutomation {
  key: string;
  label: string;
  scope: string;
  settingsTab: string;
  enabled: boolean;
  lastRunAt: string | null;
  nextRunAt: string | null;
  intervalHours: number | null;
}

function headers() {
  const token = localStorage.getItem('auth_token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

export function useSellerAutomation() {
  const [automations, setAutomations] = useState<SellerAutomation[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/api/seller/automation/status', { headers: headers() });
      const json = await res.json();
      if (json?.success && Array.isArray(json.automations)) setAutomations(json.automations);
    } catch {
      // Cabecalho e informativo: se o status falhar, a aba segue utilizavel.
    } finally {
      setLoading(false);
    }
  }, []);

  // O cabecalho e montado por aba e nao sabe quando uma execucao manual termina,
  // entao revalidamos periodicamente e ao voltar para a janela.
  useEffect(() => {
    refresh();
    const timer = window.setInterval(refresh, 60000);
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    return () => { window.clearInterval(timer); window.removeEventListener('focus', onFocus); };
  }, [refresh]);

  const byKey = useCallback(
    (key: string) => automations.find((item) => item.key === key) || null,
    [automations],
  );

  return { automations, loading, refresh, byKey };
}
